export enum TableRequisitionFilter {
    RequisitionStatusFilter = 0,
    SearchBarFilter = 1,
    RequisitionAssigneeFilter = 2,
}